import PageContainer from "../components/PageContainer"
import PageTitle from "../components/PageTitle"

import facebook from '../static/images/contacts/facebook.png';
import tiktok from '../static/images/contacts/tiktok.png';
import youtube from '../static/images/contacts/youtube.png';
import pencil from '../static/images/contacts/pencil.png';
import mail from '../static/images/contacts/mail.png';
import instagram from '../static/images/contacts/instagram.png';
import foto from '../static/images/contacts/foto.jpg';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Contacts = () => {
    const { t } = useTranslation();
    return (
        <PageContainer items="center">
            <PageTitle title="Contatti" />
            <img src={foto} alt="Foto" className="rounded-xl mb-4 xl:w-[1000px]" />
            <div className="w-full font-signature text-center text-3xl text-[#b05704] m-4">
                {t('Contacts.discoverWildSide')}
            </div>
            <h2 className="my-8 text-center">{t('Contacts.contactUs')}</h2>
            <Link to="mailto:info@ticinowild.ch"><div className="flex flex-col md:flex-row items-center gap-8 text-xl self-center">
                <img src={mail} alt="Email" className="w-12 h-12 md:w-20 md:h-20" />
                <div>info@ticinowild.ch</div>
            </div></Link>

            <h2 className="mt-32 mb-4 text-center">{t('Contacts.followUsOnSocial')}</h2>
            <div className="flex items-center gap-8 self-center">
                <Link to="https://www.facebook.com/profile.php?id=100093522121374" target="_blank"><img src={facebook} alt="Facebook" className="w-12 h-12 md:w-20 md:h-20" /></Link>
                <Link to="https://www.instagram.com/ticinowild/?igsh=NzJydm9nY3AycjFk#" target="_blank"><img src={instagram} alt="Instagram" className="w-12 h-12 md:w-20 md:h-20" /></Link>
                <Link to="https://www.tiktok.com/@ticinowild?is_from_webapp=1&sender_device=pc" target="_blank"><img src={youtube} alt="Youtube" className="w-12 h-12 md:w-20 md:h-20" /></Link>
                <Link to="https://www.youtube.com/@TicinoWild" target="_blank"><img src={tiktok} alt="Tiktok" className="w-12 h-12 md:w-20 md:h-20" /></Link>
            </div>

            <h2 className="mt-32 mb-4 text-center">{t('Contacts.becomeAPartner')}</h2>
            <Link to="https://forms.gle/iaEmYH2kNB7M2Gg59" target="_blank"><div className="flex flex-col md:flex-row items-center gap-8 text-xl self-center">
                <img src={pencil} alt="Email" className="w-12 h-12 md:w-20 md:h-20" />
                <div>{t('Contacts.fillInTheForm')}</div>
            </div></Link>

            <h2 className="mt-32 mb-4 text-center">{t('Contacts.suggestActivity')}</h2>
            <Link to="https://forms.gle/52rGLsdquxzniaDz6" target="_blank"><div className="flex flex-col md:flex-row items-center gap-8 text-xl self-center">
                <img src={pencil} alt="Email" className="w-12 h-12 md:w-20 md:h-20" />
                <div>{t('Contacts.sendAReport')}</div>
            </div></Link>

        </PageContainer>
    )
}

export default Contacts